// @flow

import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import NavLink from 'react-router-dom/NavLink';

import { colors } from '../style';

const Root = styled.div`
  display: flex;
  align-items: center;

  background-color: #3C3C3C;
  color: #FCFCFC;
`;

const NavItem = styled(NavLink)`
  padding: 0 15px;

  text-transform: lowercase;
  text-decoration: none;

  color: ${colors.white};

  &.${props => props.activeClassName} {
    color: ${colors.grey};
  }
`;

NavItem.defaultProps = {
  activeClassName: 'active',
};

const ITEMS = [
  { slug: 'professionals', path: '/doctor' },
  { slug: 'patients', path: '/patient' },
  { slug: 'partners', path: '/partners' },
  { slug: 'service', path: '/service' },
  { slug: 'questions', path: '/questions' },
]

function MainNav() {
  return (
    <Root>
      {ITEMS.map((item, index) => (
        <NavItem key={index} to={item.path}>
          <FormattedMessage id={`mainNav.${item.slug}`} />
        </NavItem>
      ))}
    </Root>
  );
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/Header/MainNav.js